import React from 'react';
import { IconProps } from './model/IconInterface';

const DivideIcon: React.FC<IconProps> = ({ size = 20, color = 'currentColor', fill }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={fill ? color : 'none'}
      stroke={color}
      strokeWidth="2.2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden
    >
      <line x1="5" y1="12" x2="19" y2="12" /><circle cx="12" cy="6" r="1" /><circle cx="12" cy="18" r="1" />
    </svg>
  );
};

export default DivideIcon;
